import styled from 'styled-components';
import { font } from '@/styles/template';
import { device } from '@/styles/template';

export const ArticleH1 = styled.h1`
    ${font.mobile.h1};
    @media ${device.tablet} { ${font.desktop.h1}; }
`;

export const TestH1 = styled.h1`
    ${font.mobile.h2};
    @media ${device.tablet} { ${font.desktop.h2}; }
`;

export const ArticleH2 = styled.h2`
    ${font.mobile.h2};
    @media ${device.tablet} { ${font.desktop.h2}; }
`;

export const ArticleH3 = styled.h2`
    ${font.mobile.h3};
    @media ${device.tablet} { ${font.desktop.h3}; }
`;

export const ArticleH4 = styled.h4`
    ${font.mobile.h4};
    @media ${device.tablet} { ${font.desktop.h4}; }
`;

export const BasicBigText = styled.p`
    ${font.basicBig};
    @media ${device.tablet} { ${font.basic}; }
`;

export const BasicText    = styled.p`${font.basic};`;
export const TextS        = styled.span`${font.basicS};`;
export const BoldTextS    = styled.span`${font.basicBoldS};`;
export const TextXS       = styled.span`${font.basicXS};`;
export const BoldTextXS   = styled.span`${font.basicBoldXS};`;
export const UpperCaseText = styled.span`${font.upperCase};`;
export const AccentTextL  = styled.span`${font.accentL};`;
export const AccentTextM  = styled.span`${font.accentM};`;
export const AccentTextS  = styled.span`${font.accentS};`;
